import React, { useCallback } from "react";
import { Button, Loading } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { isSpecialKind } from "../../utils/issueKind";
import { formatDate } from "../../utils/formatUtils";
import css from "./PeriodicalIssuePickerGrid.module.css";
export var NEW_SPECIAL_ISSUE = "new-issue";
var IssueCell = function (_a) {
    var _b;
    var issue = _a.issue, selected = _a.selected, onSelect = _a.onSelect;
    var formatMessage = useIntl().formatMessage;
    var handleClick = useCallback(function () { return onSelect(issue.id); }, [onSelect, issue.id]);
    var tooltip = [
        issue.label,
        issue.expectedDate ? formatDate(issue.expectedDate) : null,
        isSpecialKind(issue.kind)
            ? formatMessage({
                id: "ui-br-legaldeposits.agenda.linkPeriodical.grid.special",
            })
            : null,
        issue.linked
            ? formatMessage({
                id: "ui-br-legaldeposits.agenda.linkPeriodical.grid.taken",
            })
            : null,
    ]
        .filter(Boolean)
        .join(" — ");
    var className = [
        css.cell,
        isSpecialKind(issue.kind) && css.special,
        selected && css.selected,
    ]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("button", { type: "button", className: className, title: tooltip, "aria-pressed": selected, disabled: !issue.linkable, onClick: handleClick, "data-test-id": "link-periodical-issue-cell" },
        React.createElement("span", { className: css.cellLabel }, (_b = issue.issueNumber) !== null && _b !== void 0 ? _b : issue.label),
        issue.linked && (React.createElement("span", { className: css.marker, "aria-hidden": "true" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.badge.inMonographs" })))));
};
export var PeriodicalIssuePickerGrid = function (_a) {
    var volumes = _a.volumes, volumeId = _a.volumeId, onVolumeChange = _a.onVolumeChange, issues = _a.issues, issuesLoading = _a.issuesLoading, selected = _a.selected, onSelect = _a.onSelect;
    var handleVolumeClick = useCallback(function (id) { return function () { return onVolumeChange(id); }; }, [onVolumeChange]);
    var handleNewIssue = useCallback(function () { return onSelect(NEW_SPECIAL_ISSUE); }, [onSelect]);
    if (volumes.length === 0) {
        return (React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.linkPeriodical.volume.none" })));
    }
    return (React.createElement("div", { "data-test-id": "link-periodical-grid" },
        React.createElement("div", { className: css.volumes }, volumes.map(function (volume) { return (React.createElement(Button, { key: volume.volumeId, buttonStyle: volume.volumeId === volumeId ? "primary" : "default", marginBottom0: true, onClick: handleVolumeClick(volume.volumeId) }, volume.label)); })),
        issuesLoading ? (React.createElement(Loading, null)) : (React.createElement("div", { className: css.grid }, issues.map(function (issue) { return (React.createElement(IssueCell, { key: issue.id, issue: issue, selected: selected === issue.id, onSelect: onSelect })); }))),
        React.createElement(Button, { buttonStyle: selected === NEW_SPECIAL_ISSUE ? "primary" : "default", onClick: handleNewIssue, "data-test-id": "link-periodical-add-special" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.linkPeriodical.grid.addSpecial" }))));
};
